// extracted by mini-css-extract-plugin
export default {"wrap":"UserPreview_wrap__fbNW7","name":"UserPreview_name__iN3SK","statusIcon":"UserPreview_statusIcon__9Hb9I","email":"UserPreview_email__HWCDx"};